"use strict";
/** @module models */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataEntry = exports.TimelineEntry = void 0;
var cerealParse_1 = require("../cerealParse");
var base64 = require("base-64");
var emailjs_mime_parser_1 = require("emailjs-mime-parser");
var TimelineEntry = /** @class */ (function () {
    function TimelineEntry(id, creationTs, sender, message) {
        this.id = id;
        this.creationTs = creationTs;
        this.sender = sender;
        this.message = message;
    }
    TimelineEntry.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new TimelineEntry(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'creationTs'), cerealParse_1.ParseUtils.getString(o, 'sender'), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid TimelineEntry: ".concat(e.message));
        }
    };
    TimelineEntry.compare = function (t1, t2) {
        return (t2.creationTs.getTime() / 1000) - (t1.creationTs.getTime() / 1000);
    };
    return TimelineEntry;
}());
exports.TimelineEntry = TimelineEntry;
var DataEntry = /** @class */ (function () {
    function DataEntry(id, raw, creationTs) {
        this.id = id;
        this.raw = raw;
        this.creationTs = creationTs;
        try {
            this.mimeNode = (0, emailjs_mime_parser_1.default)(this.rawText());
        }
        catch (_a) {
            this.mimeNode = null;
        }
    }
    DataEntry.prototype.rawText = function () {
        return this.raw.join('\n');
    };
    DataEntry.prototype.rootContentText = function () {
        if (this.mimeNode == null || this.mimeNode.content == null) {
            return null;
        }
        try {
            return DataEntry.decoder.decode(this.mimeNode.content);
        }
        catch (_a) {
            return null;
        }
    };
    DataEntry.prototype.headers = function () {
        return this.mimeNode != null ? this.mimeNode.header.map(function (h) {
            var match = h.match(/([^:]*)\s*:\s*(.*)/);
            return match != null ? {
                key: match[1],
                value: match[2],
            } : {
                key: h,
                value: '',
            };
        }) : null;
    };
    DataEntry.prototype.bodyAsFormattedJSON = function () {
        var rootContent = this.rootContentText();
        if (rootContent == null) {
            return null;
        }
        try {
            return JSON.stringify(JSON.parse(rootContent), null, 4);
        }
        catch (_a) {
            return null;
        }
    };
    DataEntry.prototype.bodyAsCourier = function () {
        var rootContent = this.rootContentText();
        if (rootContent == null) {
            return null;
        }
        try {
            return base64.decode(JSON.parse(rootContent).file.data);
        }
        catch (_a) {
            return null;
        }
    };
    DataEntry.prototype.bodyAsBase64 = function () {
        var rootContent = this.rootContentText();
        if (rootContent == null) {
            return null;
        }
        try {
            return base64.decode(rootContent);
        }
        catch (_a) {
            return null;
        }
    };
    DataEntry.prototype.bodyAsMime = function () {
        if (this.mimeNode == null) {
            return [];
        }
        try {
            var findContent_1 = function (root) {
                var _a;
                return (_a = (root.content != null ? [{
                        content: DataEntry.decoder.decode(root.content),
                        contentType: root.contentType != null ? root.contentType.initial : 'Unknown',
                    }] : [])).concat.apply(_a, root.childNodes.map(function (child) { return findContent_1(child); }));
            };
            return findContent_1(this.mimeNode);
        }
        catch (_a) {
            return [];
        }
    };
    DataEntry.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new DataEntry(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getArray(o, 'raw'), cerealParse_1.ParseUtils.getUNIXTimestampDate(o, 'creationTs')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid DataEntry: ".concat(e.message));
        }
    };
    DataEntry.decoder = new TextDecoder('utf-8');
    return DataEntry;
}());
exports.DataEntry = DataEntry;
//# sourceMappingURL=timeline.js.map